/* Prime Raw — "How it works": line + beep runs across, circles pop in turn. Replays on a loop while on screen. */
if (!customElements.get('pr-steps')) {
  customElements.define(
    'pr-steps',
    class PrSteps extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.holdMs = 3000;
        if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.classList.add('is-played', 'is-done');
          return;
        }
        this.io = new IntersectionObserver(function (entries) {
          self.visible = entries[0].isIntersecting;
          if (self.visible && !self.timer) self.play();
          if (!self.visible) { clearTimeout(self.timer); self.timer = null; }
        }, { threshold: 0.35 });
        this.io.observe(this);
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        clearTimeout(this.timer);
      }

      play() {
        var self = this;
        // Restart from the beginning: clear state, force a reflow, then start the sequence.
        this.classList.add('is-reset');
        this.classList.remove('is-played', 'is-playing', 'is-done');
        void this.offsetWidth;
        this.classList.remove('is-reset');
        this.classList.add('is-played', 'is-playing');
        var dur = parseFloat(getComputedStyle(this).getPropertyValue('--pr-dur')) || 2.6;
        this.timer = setTimeout(function () {
          self.classList.add('is-done');
          self.timer = setTimeout(function () {
            if (self.visible) self.play(); else self.timer = null;
          }, self.holdMs);
        }, (dur + 1.2) * 1000);
      }
    }
  );
}
